/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
// eslint-disable-next-line import/order
import { createSelector } from "@reduxjs/toolkit";
import { organizationTypeApi } from "./api-slice";
import { IOrganizationTypeListResponse, IOrganizationTypeResponse } from "@bvi/api-interfaces/response/manage-base-data";

export const selectOrganizationType = createSelector(
  (response?: IOrganizationTypeListResponse) => response,
  (response) => (response?.success ? response.payload.data : []),
);

export const selectOrganizationTypeListResult = () =>
  organizationTypeApi.endpoints.getOrganizationTypeList.select();

export const selectResponse = (data?: IOrganizationTypeResponse) => {
  if (!data?.success) {
    return [];
  }

  return data.payload.data;
};

